import script from "./ButtonDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDefault.vue?vue&type=script&setup=true&lang=js"

import "./ButtonDefault.vue?vue&type=style&index=0&id=0e3fa9a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3fa9a0"]])

export default __exports__